export const nodeAddedOnHandle = ({ edges, currentNodeId, handleId }) => {
  const matchingEdges = edges.filter((edge) => edge.source === currentNodeId);

  if (matchingEdges) {
    return matchingEdges.some((edge) => edge?.sourceHandle === handleId);
  }

  return false;
};
